import React from "react";
import { Row, Col } from "reactstrap";

import { TileGroup } from "../../api";
import NavTile from "./NavTile";

interface TileGroupRowProps {
  tileGroup: TileGroup
}

const TileGroupRow: React.FC<TileGroupRowProps> = ({
  tileGroup
}) => {
  return (
    <>
      {!!tileGroup.title && (
        <Row>
          <Col>
            <div className="fs-9 fw-10 mb-2">{tileGroup.title}</div>
          </Col>
        </Row>)}
      <Row className="mb-4">
        {tileGroup.items.map(({ text, url, isActive, imageUrl }, index) => (
          <Col xs={12} sm={6} md={4} lg={3} xl={2} className="c-tile mb-4" key={index}>
            <NavTile
              label={text}
              action={url}
              isActive={isActive}
              image={imageUrl} />
          </Col>
        ))}
      </Row>
    </>
  );
}

export default TileGroupRow;
